/** Declares public routes while keeping page composition outside the application shell. */
import { Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { lazy, Suspense } from 'react';

const HomePage = lazy(() =>
  import('../presentation/pages/HomePage').then((module) => ({ default: module.HomePage })),
);
const AboutPage = lazy(() =>
  import('../presentation/pages/AboutPage').then((module) => ({ default: module.AboutPage })),
);
const ProjectsPage = lazy(() =>
  import('../presentation/pages/ProjectsPage').then((module) => ({ default: module.ProjectsPage })),
);
const ProjectDetailsPage = lazy(() =>
  import('../presentation/pages/ProjectDetailsPage').then((module) => ({ default: module.ProjectDetailsPage })),
);
const ContactPage = lazy(() =>
  import('../presentation/pages/ContactPage').then((module) => ({ default: module.ContactPage })),
);
const NotFoundPage = lazy(() =>
  import('../presentation/pages/NotFoundPage').then((module) => ({ default: module.NotFoundPage })),
);
const LoginPage = lazy(() =>
  import('../presentation/pages/LoginPage').then((module) => ({ default: module.LoginPage })),
);
const DatabasePage = lazy(() =>
  import('../presentation/pages/DatabasePage').then((module) => ({ default: module.DatabasePage })),
);

const ProtectedAdminRoute = lazy(() =>
  import('../features/admin/presentation/components/ProtectedAdminRoute').then((module) => ({
    default: module.ProtectedAdminRoute,
  })),
);

export function AppRouter() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <Suspense
        fallback={
          <div className="route-loader" role="status" aria-live="polite">
            <span /> Loading portfolio…
          </div>
        }
      >
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/projects/:projectSlug" element={<ProjectDetailsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/db"
            element={
              <ProtectedAdminRoute>
                <DatabasePage />
              </ProtectedAdminRoute>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </AnimatePresence>
  );
}
